module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1040-49b6030cd39164dd7207de754539ef96.png";